import { DataLoader } from 'src/app/services/data-loader/data-loader';

export const createCase4 = () => {
    return new DataLoader('', async function (queryContext, cancellationToken) {
        // wait
        await new Promise((resolve) => setTimeout(resolve, 1000));
        this.emitter.emit({
            data: [
                {
                    date: '2025-07-24',
                    sum_daily_active_users: 239332,
                    new_users: 11867,
                    revenue_gross_usd: 84186.29,
                    inapp_revenue_gross_usd: 74019.61,
                    ad_revenue_gross_usd: 10166.68,
                    revenue_gross_pln: 304697.91,
                    inapp_revenue_gross_pln: 267901.08,
                    ad_revenue_gross_pln: 36796.82,
                    revenue_net_usd: 58291.28,
                    inapp_revenue_net_usd: 48124.6,
                    ad_revenue_net_usd: 10166.68,
                    revenue_net_pln: 210975.39,
                    inapp_revenue_net_pln: 174178.56,
                    ad_revenue_net_pln: 36796.82,
                    cnt_first_transaction: 1066,
                    transactions: 10574,
                    wavg_ARPDAU_gross_usd: 0.35,
                    inapp_wavg_ARPDAU_gross_usd: 0.31,
                    ad_wavg_ARPDAU_gross_usd: 0.04,
                    wavg_ARPDAU_gross_pln: 1.27,
                    inapp_wavg_ARPDAU_gross_pln: 1.12,
                    ad_wavg_ARPDAU_gross_pln: 0.15,
                    wavg_ARPDAU_net_usd: 0.24,
                    inapp_wavg_ARPDAU_net_usd: 0.2,
                    ad_wavg_ARPDAU_net_usd: 0.04,
                    wavg_ARPDAU_net_pln: 0.88,
                    inapp_wavg_ARPDAU_net_pln: 0.73,
                    ad_wavg_ARPDAU_net_pln: 0.15,
                    wavg_conversion_rate: 0.029,
                },
                {
                    date: '2025-07-25',
                    sum_daily_active_users: 236081,
                    new_users: 11331,
                    revenue_gross_usd: 86670.46,
                    inapp_revenue_gross_usd: 76801.11,
                    ad_revenue_gross_usd: 9869.35,
                    revenue_gross_pln: 313514.26,
                    inapp_revenue_gross_pln: 277813.73,
                    ad_revenue_gross_pln: 35700.52,
                    revenue_net_usd: 59883.98,
                    inapp_revenue_net_usd: 50014.63,
                    ad_revenue_net_usd: 9869.35,
                    revenue_net_pln: 216619.14,
                    inapp_revenue_net_pln: 180918.62,
                    ad_revenue_net_pln: 35700.52,
                    cnt_first_transaction: 1065,
                    transactions: 10704,
                    wavg_ARPDAU_gross_usd: 0.37,
                    inapp_wavg_ARPDAU_gross_usd: 0.33,
                    ad_wavg_ARPDAU_gross_usd: 0.04,
                    wavg_ARPDAU_gross_pln: 1.33,
                    inapp_wavg_ARPDAU_gross_pln: 1.18,
                    ad_wavg_ARPDAU_gross_pln: 0.15,
                    wavg_ARPDAU_net_usd: 0.25,
                    inapp_wavg_ARPDAU_net_usd: 0.21,
                    ad_wavg_ARPDAU_net_usd: 0.04,
                    wavg_ARPDAU_net_pln: 0.92,
                    inapp_wavg_ARPDAU_net_pln: 0.77,
                    ad_wavg_ARPDAU_net_pln: 0.15,
                    wavg_conversion_rate: 0.0303,
                },
                {
                    date: '2025-07-26',
                    sum_daily_active_users: 235113,
                    new_users: 13638,
                    revenue_gross_usd: 86296.95,
                    inapp_revenue_gross_usd: 76116.82,
                    ad_revenue_gross_usd: 10180.14,
                    revenue_gross_pln: 312154.02,
                    inapp_revenue_gross_pln: 275329.76,
                    ad_revenue_gross_pln: 36824.26,
                    revenue_net_usd: 59571.07,
                    inapp_revenue_net_usd: 49390.93,
                    ad_revenue_net_usd: 10180.14,
                    revenue_net_pln: 215480.95,
                    inapp_revenue_net_pln: 178656.69,
                    ad_revenue_net_pln: 36824.26,
                    cnt_first_transaction: 1133,
                    transactions: 10786,
                    wavg_ARPDAU_gross_usd: 0.37,
                    inapp_wavg_ARPDAU_gross_usd: 0.32,
                    ad_wavg_ARPDAU_gross_usd: 0.04,
                    wavg_ARPDAU_gross_pln: 1.33,
                    inapp_wavg_ARPDAU_gross_pln: 1.17,
                    ad_wavg_ARPDAU_gross_pln: 0.16,
                    wavg_ARPDAU_net_usd: 0.25,
                    inapp_wavg_ARPDAU_net_usd: 0.21,
                    ad_wavg_ARPDAU_net_usd: 0.04,
                    wavg_ARPDAU_net_pln: 0.92,
                    inapp_wavg_ARPDAU_net_pln: 0.76,
                    ad_wavg_ARPDAU_net_pln: 0.16,
                    wavg_conversion_rate: 0.0299,
                },
                {
                    date: '2025-07-27',
                    sum_daily_active_users: 246313,
                    new_users: 14879,
                    revenue_gross_usd: 93130.54,
                    inapp_revenue_gross_usd: 82381.69,
                    ad_revenue_gross_usd: 10748.85,
                    revenue_gross_pln: 336593.17,
                    inapp_revenue_gross_pln: 297752.39,
                    ad_revenue_gross_pln: 38840.78,
                    revenue_net_usd: 64163.23,
                    inapp_revenue_net_usd: 53414.38,
                    ad_revenue_net_usd: 10748.85,
                    revenue_net_pln: 231900.17,
                    inapp_revenue_net_pln: 193059.39,
                    ad_revenue_net_pln: 38840.78,
                    cnt_first_transaction: 1395,
                    transactions: 11787,
                    wavg_ARPDAU_gross_usd: 0.38,
                    inapp_wavg_ARPDAU_gross_usd: 0.33,
                    ad_wavg_ARPDAU_gross_usd: 0.04,
                    wavg_ARPDAU_gross_pln: 1.37,
                    inapp_wavg_ARPDAU_gross_pln: 1.21,
                    ad_wavg_ARPDAU_gross_pln: 0.16,
                    wavg_ARPDAU_net_usd: 0.26,
                    inapp_wavg_ARPDAU_net_usd: 0.22,
                    ad_wavg_ARPDAU_net_usd: 0.04,
                    wavg_ARPDAU_net_pln: 0.94,
                    inapp_wavg_ARPDAU_net_pln: 0.78,
                    ad_wavg_ARPDAU_net_pln: 0.16,
                    wavg_conversion_rate: 0.031,
                },
                {
                    date: '2025-07-28',
                    sum_daily_active_users: 249216,
                    new_users: 16025,
                    revenue_gross_usd: 86890.41,
                    inapp_revenue_gross_usd: 76562.43,
                    ad_revenue_gross_usd: 10327.98,
                    revenue_gross_pln: 319579.1,
                    inapp_revenue_gross_pln: 281597.19,
                    ad_revenue_gross_pln: 37981.9,
                    revenue_net_usd: 59988.67,
                    inapp_revenue_net_usd: 49660.7,
                    ad_revenue_net_usd: 10327.98,
                    revenue_net_pln: 220635.83,
                    inapp_revenue_net_pln: 182653.93,
                    ad_revenue_net_pln: 37981.9,
                    cnt_first_transaction: 1152,
                    transactions: 11116,
                    wavg_ARPDAU_gross_usd: 0.35,
                    inapp_wavg_ARPDAU_gross_usd: 0.31,
                    ad_wavg_ARPDAU_gross_usd: 0.04,
                    wavg_ARPDAU_gross_pln: 1.28,
                    inapp_wavg_ARPDAU_gross_pln: 1.13,
                    ad_wavg_ARPDAU_gross_pln: 0.15,
                    wavg_ARPDAU_net_usd: 0.24,
                    inapp_wavg_ARPDAU_net_usd: 0.2,
                    ad_wavg_ARPDAU_net_usd: 0.04,
                    wavg_ARPDAU_net_pln: 0.89,
                    inapp_wavg_ARPDAU_net_pln: 0.73,
                    ad_wavg_ARPDAU_net_pln: 0.15,
                    wavg_conversion_rate: 0.0284,
                },
                {
                    date: '2025-07-29',
                    sum_daily_active_users: 250562,
                    new_users: 14888,
                    revenue_gross_usd: 82758.68,
                    inapp_revenue_gross_usd: 72856.08,
                    ad_revenue_gross_usd: 9902.6,
                    revenue_gross_pln: 306693.6,
                    inapp_revenue_gross_pln: 270000.42,
                    ad_revenue_gross_pln: 36693.19,
                    revenue_net_usd: 57234.74,
                    inapp_revenue_net_usd: 47332.14,
                    ad_revenue_net_usd: 9902.6,
                    revenue_net_pln: 212104.35,
                    inapp_revenue_net_pln: 175411.16,
                    ad_revenue_net_pln: 36693.19,
                    cnt_first_transaction: 1167,
                    transactions: 10651,
                    wavg_ARPDAU_gross_usd: 0.33,
                    inapp_wavg_ARPDAU_gross_usd: 0.29,
                    ad_wavg_ARPDAU_gross_usd: 0.04,
                    wavg_ARPDAU_gross_pln: 1.22,
                    inapp_wavg_ARPDAU_gross_pln: 1.08,
                    ad_wavg_ARPDAU_gross_pln: 0.15,
                    wavg_ARPDAU_net_usd: 0.23,
                    inapp_wavg_ARPDAU_net_usd: 0.19,
                    ad_wavg_ARPDAU_net_usd: 0.04,
                    wavg_ARPDAU_net_pln: 0.85,
                    inapp_wavg_ARPDAU_net_pln: 0.7,
                    ad_wavg_ARPDAU_net_pln: 0.15,
                    wavg_conversion_rate: 0.0281,
                },
                {
                    date: '2025-07-30',
                    sum_daily_active_users: 248543,
                    new_users: 15168,
                    revenue_gross_usd: 83859.78,
                    inapp_revenue_gross_usd: 73922.9,
                    ad_revenue_gross_usd: 9936.88,
                    revenue_gross_pln: 313572.84,
                    inapp_revenue_gross_pln: 276417.02,
                    ad_revenue_gross_pln: 37155.82,
                    revenue_net_usd: 57887.17,
                    inapp_revenue_net_usd: 47950.29,
                    ad_revenue_net_usd: 9936.88,
                    revenue_net_pln: 216454.65,
                    inapp_revenue_net_pln: 179298.83,
                    ad_revenue_net_pln: 37155.82,
                    cnt_first_transaction: 1139,
                    transactions: 10720,
                    wavg_ARPDAU_gross_usd: 0.34,
                    inapp_wavg_ARPDAU_gross_usd: 0.3,
                    ad_wavg_ARPDAU_gross_usd: 0.04,
                    wavg_ARPDAU_gross_pln: 1.26,
                    inapp_wavg_ARPDAU_gross_pln: 1.11,
                    ad_wavg_ARPDAU_gross_pln: 0.15,
                    wavg_ARPDAU_net_usd: 0.23,
                    inapp_wavg_ARPDAU_net_usd: 0.19,
                    ad_wavg_ARPDAU_net_usd: 0.04,
                    wavg_ARPDAU_net_pln: 0.87,
                    inapp_wavg_ARPDAU_net_pln: 0.72,
                    ad_wavg_ARPDAU_net_pln: 0.15,
                    wavg_conversion_rate: 0.0283,
                },
                {
                    date: '2025-07-31',
                    sum_daily_active_users: 246039,
                    new_users: 13015,
                    revenue_gross_usd: 88621,
                    inapp_revenue_gross_usd: 79076.96,
                    ad_revenue_gross_usd: 9544.04,
                    revenue_gross_pln: 331649.28,
                    inapp_revenue_gross_pln: 295924.39,
                    ad_revenue_gross_pln: 35724.89,
                    revenue_net_usd: 60921.12,
                    inapp_revenue_net_usd: 51377.09,
                    ad_revenue_net_usd: 9544.04,
                    revenue_net_pln: 227987.22,
                    inapp_revenue_net_pln: 192262.33,
                    ad_revenue_net_pln: 35724.89,
                    cnt_first_transaction: 1107,
                    transactions: 11292,
                    wavg_ARPDAU_gross_usd: 0.36,
                    inapp_wavg_ARPDAU_gross_usd: 0.32,
                    ad_wavg_ARPDAU_gross_usd: 0.04,
                    wavg_ARPDAU_gross_pln: 1.35,
                    inapp_wavg_ARPDAU_gross_pln: 1.2,
                    ad_wavg_ARPDAU_gross_pln: 0.15,
                    wavg_ARPDAU_net_usd: 0.25,
                    inapp_wavg_ARPDAU_net_usd: 0.21,
                    ad_wavg_ARPDAU_net_usd: 0.04,
                    wavg_ARPDAU_net_pln: 0.93,
                    inapp_wavg_ARPDAU_net_pln: 0.78,
                    ad_wavg_ARPDAU_net_pln: 0.15,
                    wavg_conversion_rate: 0.0295,
                },
                {
                    date: '2025-08-01',
                    sum_daily_active_users: 242127,
                    new_users: 13645,
                    revenue_gross_usd: 93979.2,
                    inapp_revenue_gross_usd: 84829.94,
                    ad_revenue_gross_usd: 9149.26,
                    revenue_gross_pln: 346430.9,
                    inapp_revenue_gross_pln: 312704.44,
                    ad_revenue_gross_pln: 33726.46,
                    revenue_net_usd: 64196.65,
                    inapp_revenue_net_usd: 55047.39,
                    ad_revenue_net_usd: 9149.26,
                    revenue_net_pln: 236644.95,
                    inapp_revenue_net_pln: 202918.49,
                    ad_revenue_net_pln: 33726.46,
                    cnt_first_transaction: 1145,
                    transactions: 11386,
                    wavg_ARPDAU_gross_usd: 0.39,
                    inapp_wavg_ARPDAU_gross_usd: 0.35,
                    ad_wavg_ARPDAU_gross_usd: 0.04,
                    wavg_ARPDAU_gross_pln: 1.43,
                    inapp_wavg_ARPDAU_gross_pln: 1.29,
                    ad_wavg_ARPDAU_gross_pln: 0.14,
                    wavg_ARPDAU_net_usd: 0.27,
                    inapp_wavg_ARPDAU_net_usd: 0.23,
                    ad_wavg_ARPDAU_net_usd: 0.04,
                    wavg_ARPDAU_net_pln: 0.98,
                    inapp_wavg_ARPDAU_net_pln: 0.84,
                    ad_wavg_ARPDAU_net_pln: 0.14,
                    wavg_conversion_rate: 0.0309,
                },
                {
                    date: '2025-08-02',
                    sum_daily_active_users: 238297,
                    new_users: 13132,
                    revenue_gross_usd: 89747.32,
                    inapp_revenue_gross_usd: 80532.4,
                    ad_revenue_gross_usd: 9214.92,
                    revenue_gross_pln: 330832.35,
                    inapp_revenue_gross_pln: 296863.47,
                    ad_revenue_gross_pln: 33968.88,
                    revenue_net_usd: 61588.49,
                    inapp_revenue_net_usd: 52373.57,
                    ad_revenue_net_usd: 9214.92,
                    revenue_net_pln: 227031.47,
                    inapp_revenue_net_pln: 193062.59,
                    ad_revenue_net_pln: 33968.88,
                    cnt_first_transaction: 1239,
                    transactions: 11316,
                    wavg_ARPDAU_gross_usd: 0.38,
                    inapp_wavg_ARPDAU_gross_usd: 0.34,
                    ad_wavg_ARPDAU_gross_usd: 0.04,
                    wavg_ARPDAU_gross_pln: 1.39,
                    inapp_wavg_ARPDAU_gross_pln: 1.25,
                    ad_wavg_ARPDAU_gross_pln: 0.14,
                    wavg_ARPDAU_net_usd: 0.26,
                    inapp_wavg_ARPDAU_net_usd: 0.22,
                    ad_wavg_ARPDAU_net_usd: 0.04,
                    wavg_ARPDAU_net_pln: 0.95,
                    inapp_wavg_ARPDAU_net_pln: 0.81,
                    ad_wavg_ARPDAU_net_pln: 0.14,
                    wavg_conversion_rate: 0.0306,
                },
                {
                    date: '2025-08-03',
                    sum_daily_active_users: 248245,
                    new_users: 14470,
                    revenue_gross_usd: 95703.89,
                    inapp_revenue_gross_usd: 85525.34,
                    ad_revenue_gross_usd: 10178.55,
                    revenue_gross_pln: 352514.47,
                    inapp_revenue_gross_pln: 315024.17,
                    ad_revenue_gross_pln: 37490.29,
                    revenue_net_usd: 65712.87,
                    inapp_revenue_net_usd: 55534.32,
                    ad_revenue_net_usd: 10178.55,
                    revenue_net_pln: 242045.91,
                    inapp_revenue_net_pln: 204555.61,
                    ad_revenue_net_pln: 37490.29,
                    cnt_first_transaction: 1375,
                    transactions: 12183,
                    wavg_ARPDAU_gross_usd: 0.39,
                    inapp_wavg_ARPDAU_gross_usd: 0.34,
                    ad_wavg_ARPDAU_gross_usd: 0.04,
                    wavg_ARPDAU_gross_pln: 1.42,
                    inapp_wavg_ARPDAU_gross_pln: 1.27,
                    ad_wavg_ARPDAU_gross_pln: 0.15,
                    wavg_ARPDAU_net_usd: 0.26,
                    inapp_wavg_ARPDAU_net_usd: 0.22,
                    ad_wavg_ARPDAU_net_usd: 0.04,
                    wavg_ARPDAU_net_pln: 0.98,
                    inapp_wavg_ARPDAU_net_pln: 0.82,
                    ad_wavg_ARPDAU_net_pln: 0.15,
                    wavg_conversion_rate: 0.0317,
                },
                {
                    date: '2025-08-04',
                    sum_daily_active_users: 248102,
                    new_users: 13897,
                    revenue_gross_usd: 88173.51,
                    inapp_revenue_gross_usd: 78425.23,
                    ad_revenue_gross_usd: 9748.28,
                    revenue_gross_pln: 325429.94,
                    inapp_revenue_gross_pln: 289451.8,
                    ad_revenue_gross_pln: 35978.14,
                    revenue_net_usd: 60683.21,
                    inapp_revenue_net_usd: 50934.93,
                    ad_revenue_net_usd: 9748.28,
                    revenue_net_pln: 223969.06,
                    inapp_revenue_net_pln: 187990.92,
                    ad_revenue_net_pln: 35978.14,
                    cnt_first_transaction: 1275,
                    transactions: 11424,
                    wavg_ARPDAU_gross_usd: 0.36,
                    inapp_wavg_ARPDAU_gross_usd: 0.32,
                    ad_wavg_ARPDAU_gross_usd: 0.04,
                    wavg_ARPDAU_gross_pln: 1.31,
                    inapp_wavg_ARPDAU_gross_pln: 1.17,
                    ad_wavg_ARPDAU_gross_pln: 0.15,
                    wavg_ARPDAU_net_usd: 0.24,
                    inapp_wavg_ARPDAU_net_usd: 0.21,
                    ad_wavg_ARPDAU_net_usd: 0.04,
                    wavg_ARPDAU_net_pln: 0.9,
                    inapp_wavg_ARPDAU_net_pln: 0.76,
                    ad_wavg_ARPDAU_net_pln: 0.15,
                    wavg_conversion_rate: 0.0297,
                },
                {
                    date: '2025-08-05',
                    sum_daily_active_users: 250149,
                    new_users: 15132,
                    revenue_gross_usd: 88182.95,
                    inapp_revenue_gross_usd: 77942.98,
                    ad_revenue_gross_usd: 10239.97,
                    revenue_gross_pln: 325931.83,
                    inapp_revenue_gross_pln: 288079.76,
                    ad_revenue_gross_pln: 37852.08,
                    revenue_net_usd: 60813.3,
                    inapp_revenue_net_usd: 50573.33,
                    ad_revenue_net_usd: 10239.97,
                    revenue_net_pln: 224770.82,
                    inapp_revenue_net_pln: 186918.75,
                    ad_revenue_net_pln: 37852.08,
                    cnt_first_transaction: 1338,
                    transactions: 11390,
                    wavg_ARPDAU_gross_usd: 0.35,
                    inapp_wavg_ARPDAU_gross_usd: 0.31,
                    ad_wavg_ARPDAU_gross_usd: 0.04,
                    wavg_ARPDAU_gross_pln: 1.3,
                    inapp_wavg_ARPDAU_gross_pln: 1.15,
                    ad_wavg_ARPDAU_gross_pln: 0.15,
                    wavg_ARPDAU_net_usd: 0.24,
                    inapp_wavg_ARPDAU_net_usd: 0.2,
                    ad_wavg_ARPDAU_net_usd: 0.04,
                    wavg_ARPDAU_net_pln: 0.9,
                    inapp_wavg_ARPDAU_net_pln: 0.75,
                    ad_wavg_ARPDAU_net_pln: 0.15,
                    wavg_conversion_rate: 0.0296,
                },
                {
                    date: '2025-08-06',
                    sum_daily_active_users: 249975,
                    new_users: 15838,
                    revenue_gross_usd: 84947.85,
                    inapp_revenue_gross_usd: 74908.02,
                    ad_revenue_gross_usd: 10039.83,
                    revenue_gross_pln: 311243.11,
                    inapp_revenue_gross_pln: 274455.39,
                    ad_revenue_gross_pln: 36787.71,
                    revenue_net_usd: 58734.4,
                    inapp_revenue_net_usd: 48694.56,
                    ad_revenue_net_usd: 10039.83,
                    revenue_net_pln: 215198.95,
                    inapp_revenue_net_pln: 178411.24,
                    ad_revenue_net_pln: 36787.71,
                    cnt_first_transaction: 1379,
                    transactions: 10935,
                    wavg_ARPDAU_gross_usd: 0.34,
                    inapp_wavg_ARPDAU_gross_usd: 0.3,
                    ad_wavg_ARPDAU_gross_usd: 0.04,
                    wavg_ARPDAU_gross_pln: 1.25,
                    inapp_wavg_ARPDAU_gross_pln: 1.1,
                    ad_wavg_ARPDAU_gross_pln: 0.15,
                    wavg_ARPDAU_net_usd: 0.23,
                    inapp_wavg_ARPDAU_net_usd: 0.19,
                    ad_wavg_ARPDAU_net_usd: 0.04,
                    wavg_ARPDAU_net_pln: 0.86,
                    inapp_wavg_ARPDAU_net_pln: 0.71,
                    ad_wavg_ARPDAU_net_pln: 0.15,
                    wavg_conversion_rate: 0.0289,
                },
                {
                    date: '2025-08-07',
                    sum_daily_active_users: 247202,
                    new_users: 13651,
                    revenue_gross_usd: 85872.69,
                    inapp_revenue_gross_usd: 76160.39,
                    ad_revenue_gross_usd: 9712.3,
                    revenue_gross_pln: 312907.62,
                    inapp_revenue_gross_pln: 277518.03,
                    ad_revenue_gross_pln: 35389.59,
                    revenue_net_usd: 59204.3,
                    inapp_revenue_net_usd: 49492,
                    ad_revenue_net_usd: 9712.3,
                    revenue_net_pln: 215731.86,
                    inapp_revenue_net_pln: 180342.27,
                    ad_revenue_net_pln: 35389.59,
                    cnt_first_transaction: 1308,
                    transactions: 10956,
                    wavg_ARPDAU_gross_usd: 0.35,
                    inapp_wavg_ARPDAU_gross_usd: 0.31,
                    ad_wavg_ARPDAU_gross_usd: 0.04,
                    wavg_ARPDAU_gross_pln: 1.27,
                    inapp_wavg_ARPDAU_gross_pln: 1.12,
                    ad_wavg_ARPDAU_gross_pln: 0.14,
                    wavg_ARPDAU_net_usd: 0.24,
                    inapp_wavg_ARPDAU_net_usd: 0.2,
                    ad_wavg_ARPDAU_net_usd: 0.04,
                    wavg_ARPDAU_net_pln: 0.87,
                    inapp_wavg_ARPDAU_net_pln: 0.73,
                    ad_wavg_ARPDAU_net_pln: 0.14,
                    wavg_conversion_rate: 0.0292,
                },
                {
                    date: '2025-08-08',
                    sum_daily_active_users: 242473,
                    new_users: 12284,
                    revenue_gross_usd: 105638.53,
                    inapp_revenue_gross_usd: 96110.81,
                    ad_revenue_gross_usd: 9527.72,
                    revenue_gross_pln: 385341.82,
                    inapp_revenue_gross_pln: 350587.19,
                    ad_revenue_gross_pln: 34754.63,
                    revenue_net_usd: 71864.04,
                    inapp_revenue_net_usd: 62336.32,
                    ad_revenue_net_usd: 9527.72,
                    revenue_net_pln: 262141.28,
                    inapp_revenue_net_pln: 227386.65,
                    ad_revenue_net_pln: 34754.63,
                    cnt_first_transaction: 1310,
                    transactions: 12799,
                    wavg_ARPDAU_gross_usd: 0.44,
                    inapp_wavg_ARPDAU_gross_usd: 0.4,
                    ad_wavg_ARPDAU_gross_usd: 0.04,
                    wavg_ARPDAU_gross_pln: 1.59,
                    inapp_wavg_ARPDAU_gross_pln: 1.45,
                    ad_wavg_ARPDAU_gross_pln: 0.14,
                    wavg_ARPDAU_net_usd: 0.3,
                    inapp_wavg_ARPDAU_net_usd: 0.26,
                    ad_wavg_ARPDAU_net_usd: 0.04,
                    wavg_ARPDAU_net_pln: 1.08,
                    inapp_wavg_ARPDAU_net_pln: 0.94,
                    ad_wavg_ARPDAU_net_pln: 0.14,
                    wavg_conversion_rate: 0.0363,
                },
                {
                    date: '2025-08-09',
                    sum_daily_active_users: 238488,
                    new_users: 13306,
                    revenue_gross_usd: 96584.94,
                    inapp_revenue_gross_usd: 86910.95,
                    ad_revenue_gross_usd: 9673.99,
                    revenue_gross_pln: 352312.17,
                    inapp_revenue_gross_pln: 317024.24,
                    ad_revenue_gross_pln: 35287.93,
                    revenue_net_usd: 66143.83,
                    inapp_revenue_net_usd: 56469.84,
                    ad_revenue_net_usd: 9673.99,
                    revenue_net_pln: 241272.33,
                    inapp_revenue_net_pln: 205984.41,
                    ad_revenue_net_pln: 35287.93,
                    cnt_first_transaction: 1281,
                    transactions: 11821,
                    wavg_ARPDAU_gross_usd: 0.4,
                    inapp_wavg_ARPDAU_gross_usd: 0.36,
                    ad_wavg_ARPDAU_gross_usd: 0.04,
                    wavg_ARPDAU_gross_pln: 1.48,
                    inapp_wavg_ARPDAU_gross_pln: 1.33,
                    ad_wavg_ARPDAU_gross_pln: 0.15,
                    wavg_ARPDAU_net_usd: 0.28,
                    inapp_wavg_ARPDAU_net_usd: 0.24,
                    ad_wavg_ARPDAU_net_usd: 0.04,
                    wavg_ARPDAU_net_pln: 1.01,
                    inapp_wavg_ARPDAU_net_pln: 0.86,
                    ad_wavg_ARPDAU_net_pln: 0.15,
                    wavg_conversion_rate: 0.0344,
                },
                {
                    date: '2025-08-10',
                    sum_daily_active_users: 245747,
                    new_users: 13719,
                    revenue_gross_usd: 98935.88,
                    inapp_revenue_gross_usd: 88369.83,
                    ad_revenue_gross_usd: 10566.05,
                    revenue_gross_pln: 360688.67,
                    inapp_revenue_gross_pln: 322171.03,
                    ad_revenue_gross_pln: 38517.64,
                    revenue_net_usd: 67947.02,
                    inapp_revenue_net_usd: 57380.97,
                    ad_revenue_net_usd: 10566.05,
                    revenue_net_pln: 247713.17,
                    inapp_revenue_net_pln: 209195.53,
                    ad_revenue_net_pln: 38517.64,
                    cnt_first_transaction: 1448,
                    transactions: 12237,
                    wavg_ARPDAU_gross_usd: 0.4,
                    inapp_wavg_ARPDAU_gross_usd: 0.36,
                    ad_wavg_ARPDAU_gross_usd: 0.04,
                    wavg_ARPDAU_gross_pln: 1.47,
                    inapp_wavg_ARPDAU_gross_pln: 1.31,
                    ad_wavg_ARPDAU_gross_pln: 0.16,
                    wavg_ARPDAU_net_usd: 0.28,
                    inapp_wavg_ARPDAU_net_usd: 0.23,
                    ad_wavg_ARPDAU_net_usd: 0.04,
                    wavg_ARPDAU_net_pln: 1.01,
                    inapp_wavg_ARPDAU_net_pln: 0.85,
                    ad_wavg_ARPDAU_net_pln: 0.16,
                    wavg_conversion_rate: 0.034,
                },
                {
                    date: '2025-08-11',
                    sum_daily_active_users: 247424,
                    new_users: 14426,
                    revenue_gross_usd: 95015.23,
                    inapp_revenue_gross_usd: 85145.89,
                    ad_revenue_gross_usd: 9869.34,
                    revenue_gross_pln: 348200.98,
                    inapp_revenue_gross_pln: 312030.44,
                    ad_revenue_gross_pln: 36170.54,
                    revenue_net_usd: 65042.47,
                    inapp_revenue_net_usd: 55173.12,
                    ad_revenue_net_usd: 9869.34,
                    revenue_net_pln: 238360.22,
                    inapp_revenue_net_pln: 202189.68,
                    ad_revenue_net_pln: 36170.54,
                    cnt_first_transaction: 1185,
                    transactions: 11624,
                    wavg_ARPDAU_gross_usd: 0.38,
                    inapp_wavg_ARPDAU_gross_usd: 0.34,
                    ad_wavg_ARPDAU_gross_usd: 0.04,
                    wavg_ARPDAU_gross_pln: 1.41,
                    inapp_wavg_ARPDAU_gross_pln: 1.26,
                    ad_wavg_ARPDAU_gross_pln: 0.15,
                    wavg_ARPDAU_net_usd: 0.26,
                    inapp_wavg_ARPDAU_net_usd: 0.22,
                    ad_wavg_ARPDAU_net_usd: 0.04,
                    wavg_ARPDAU_net_pln: 0.96,
                    inapp_wavg_ARPDAU_net_pln: 0.82,
                    ad_wavg_ARPDAU_net_pln: 0.15,
                    wavg_conversion_rate: 0.0315,
                },
                {
                    date: '2025-08-12',
                    sum_daily_active_users: 249275,
                    new_users: 15164,
                    revenue_gross_usd: 87946.56,
                    inapp_revenue_gross_usd: 77931.56,
                    ad_revenue_gross_usd: 10015,
                    revenue_gross_pln: 320491.85,
                    inapp_revenue_gross_pln: 283994.35,
                    ad_revenue_gross_pln: 36497.5,
                    revenue_net_usd: 60659.28,
                    inapp_revenue_net_usd: 50644.28,
                    ad_revenue_net_usd: 10015,
                    revenue_net_pln: 221052.46,
                    inapp_revenue_net_pln: 184554.96,
                    ad_revenue_net_pln: 36497.5,
                    cnt_first_transaction: 1214,
                    transactions: 10929,
                    wavg_ARPDAU_gross_usd: 0.35,
                    inapp_wavg_ARPDAU_gross_usd: 0.31,
                    ad_wavg_ARPDAU_gross_usd: 0.04,
                    wavg_ARPDAU_gross_pln: 1.29,
                    inapp_wavg_ARPDAU_gross_pln: 1.14,
                    ad_wavg_ARPDAU_gross_pln: 0.15,
                    wavg_ARPDAU_net_usd: 0.24,
                    inapp_wavg_ARPDAU_net_usd: 0.2,
                    ad_wavg_ARPDAU_net_usd: 0.04,
                    wavg_ARPDAU_net_pln: 0.89,
                    inapp_wavg_ARPDAU_net_pln: 0.74,
                    ad_wavg_ARPDAU_net_pln: 0.15,
                    wavg_conversion_rate: 0.0301,
                },
                {
                    date: '2025-08-13',
                    sum_daily_active_users: 247970,
                    new_users: 14096,
                    revenue_gross_usd: 88935.36,
                    inapp_revenue_gross_usd: 78537.38,
                    ad_revenue_gross_usd: 10397.99,
                    revenue_gross_pln: 323029.67,
                    inapp_revenue_gross_pln: 285266.02,
                    ad_revenue_gross_pln: 37763.66,
                    revenue_net_usd: 61411.99,
                    inapp_revenue_net_usd: 51014,
                    ad_revenue_net_usd: 10397.99,
                    revenue_net_pln: 223059.65,
                    inapp_revenue_net_pln: 185295.99,
                    ad_revenue_net_pln: 37763.66,
                    cnt_first_transaction: 1263,
                    transactions: 10820,
                    wavg_ARPDAU_gross_usd: 0.36,
                    inapp_wavg_ARPDAU_gross_usd: 0.32,
                    ad_wavg_ARPDAU_gross_usd: 0.04,
                    wavg_ARPDAU_gross_pln: 1.3,
                    inapp_wavg_ARPDAU_gross_pln: 1.15,
                    ad_wavg_ARPDAU_gross_pln: 0.15,
                    wavg_ARPDAU_net_usd: 0.25,
                    inapp_wavg_ARPDAU_net_usd: 0.21,
                    ad_wavg_ARPDAU_net_usd: 0.04,
                    wavg_ARPDAU_net_pln: 0.9,
                    inapp_wavg_ARPDAU_net_pln: 0.75,
                    ad_wavg_ARPDAU_net_pln: 0.15,
                    wavg_conversion_rate: 0.0302,
                },
                {
                    date: '2025-08-14',
                    sum_daily_active_users: 246571,
                    new_users: 13871,
                    revenue_gross_usd: 89516.59,
                    inapp_revenue_gross_usd: 79510.57,
                    ad_revenue_gross_usd: 10006.01,
                    revenue_gross_pln: 327447.3,
                    inapp_revenue_gross_pln: 290843.84,
                    ad_revenue_gross_pln: 36603.46,
                    revenue_net_usd: 61684.84,
                    inapp_revenue_net_usd: 51678.83,
                    ad_revenue_net_usd: 10006.01,
                    revenue_net_pln: 225639.98,
                    inapp_revenue_net_pln: 189036.52,
                    ad_revenue_net_pln: 36603.46,
                    cnt_first_transaction: 1165,
                    transactions: 11015,
                    wavg_ARPDAU_gross_usd: 0.36,
                    inapp_wavg_ARPDAU_gross_usd: 0.32,
                    ad_wavg_ARPDAU_gross_usd: 0.04,
                    wavg_ARPDAU_gross_pln: 1.33,
                    inapp_wavg_ARPDAU_gross_pln: 1.18,
                    ad_wavg_ARPDAU_gross_pln: 0.15,
                    wavg_ARPDAU_net_usd: 0.25,
                    inapp_wavg_ARPDAU_net_usd: 0.21,
                    ad_wavg_ARPDAU_net_usd: 0.04,
                    wavg_ARPDAU_net_pln: 0.92,
                    inapp_wavg_ARPDAU_net_pln: 0.77,
                    ad_wavg_ARPDAU_net_pln: 0.15,
                    wavg_conversion_rate: 0.0305,
                },
                {
                    date: '2025-08-15',
                    sum_daily_active_users: 242414,
                    new_users: 13483,
                    revenue_gross_usd: 91541.94,
                    inapp_revenue_gross_usd: 81706.55,
                    ad_revenue_gross_usd: 9835.39,
                    revenue_gross_pln: 333128.28,
                    inapp_revenue_gross_pln: 297336.53,
                    ad_revenue_gross_pln: 35791.75,
                    revenue_net_usd: 63025.9,
                    inapp_revenue_net_usd: 53190.51,
                    ad_revenue_net_usd: 9835.39,
                    revenue_net_pln: 229356.17,
                    inapp_revenue_net_pln: 193564.42,
                    ad_revenue_net_pln: 35791.75,
                    cnt_first_transaction: 1205,
                    transactions: 11136,
                    wavg_ARPDAU_gross_usd: 0.38,
                    inapp_wavg_ARPDAU_gross_usd: 0.34,
                    ad_wavg_ARPDAU_gross_usd: 0.04,
                    wavg_ARPDAU_gross_pln: 1.37,
                    inapp_wavg_ARPDAU_gross_pln: 1.23,
                    ad_wavg_ARPDAU_gross_pln: 0.15,
                    wavg_ARPDAU_net_usd: 0.26,
                    inapp_wavg_ARPDAU_net_usd: 0.22,
                    ad_wavg_ARPDAU_net_usd: 0.04,
                    wavg_ARPDAU_net_pln: 0.95,
                    inapp_wavg_ARPDAU_net_pln: 0.8,
                    ad_wavg_ARPDAU_net_pln: 0.15,
                    wavg_conversion_rate: 0.0313,
                },
                {
                    date: '2025-08-16',
                    sum_daily_active_users: 241285,
                    new_users: 14415,
                    revenue_gross_usd: 91645.81,
                    inapp_revenue_gross_usd: 81656.06,
                    ad_revenue_gross_usd: 9989.75,
                    revenue_gross_pln: 333504.49,
                    inapp_revenue_gross_pln: 297151.07,
                    ad_revenue_gross_pln: 36353.42,
                    revenue_net_usd: 63151.74,
                    inapp_revenue_net_usd: 53161.99,
                    ad_revenue_net_usd: 9989.75,
                    revenue_net_pln: 229812.91,
                    inapp_revenue_net_pln: 193459.49,
                    ad_revenue_net_pln: 36353.42,
                    cnt_first_transaction: 1266,
                    transactions: 11403,
                    wavg_ARPDAU_gross_usd: 0.38,
                    inapp_wavg_ARPDAU_gross_usd: 0.34,
                    ad_wavg_ARPDAU_gross_usd: 0.04,
                    wavg_ARPDAU_gross_pln: 1.38,
                    inapp_wavg_ARPDAU_gross_pln: 1.23,
                    ad_wavg_ARPDAU_gross_pln: 0.15,
                    wavg_ARPDAU_net_usd: 0.26,
                    inapp_wavg_ARPDAU_net_usd: 0.22,
                    ad_wavg_ARPDAU_net_usd: 0.04,
                    wavg_ARPDAU_net_pln: 0.95,
                    inapp_wavg_ARPDAU_net_pln: 0.8,
                    ad_wavg_ARPDAU_net_pln: 0.15,
                    wavg_conversion_rate: 0.032,
                },
                {
                    date: '2025-08-17',
                    sum_daily_active_users: 251453,
                    new_users: 16404,
                    revenue_gross_usd: 96459.11,
                    inapp_revenue_gross_usd: 85791.62,
                    ad_revenue_gross_usd: 10667.49,
                    revenue_gross_pln: 350959.44,
                    inapp_revenue_gross_pln: 312146.96,
                    ad_revenue_gross_pln: 38812.48,
                    revenue_net_usd: 66571,
                    inapp_revenue_net_usd: 55903.51,
                    ad_revenue_net_usd: 10667.49,
                    revenue_net_pln: 242213.8,
                    inapp_revenue_net_pln: 203401.32,
                    ad_revenue_net_pln: 38812.48,
                    cnt_first_transaction: 1456,
                    transactions: 12095,
                    wavg_ARPDAU_gross_usd: 0.38,
                    inapp_wavg_ARPDAU_gross_usd: 0.34,
                    ad_wavg_ARPDAU_gross_usd: 0.04,
                    wavg_ARPDAU_gross_pln: 1.4,
                    inapp_wavg_ARPDAU_gross_pln: 1.24,
                    ad_wavg_ARPDAU_gross_pln: 0.15,
                    wavg_ARPDAU_net_usd: 0.26,
                    inapp_wavg_ARPDAU_net_usd: 0.22,
                    ad_wavg_ARPDAU_net_usd: 0.04,
                    wavg_ARPDAU_net_pln: 0.96,
                    inapp_wavg_ARPDAU_net_pln: 0.81,
                    ad_wavg_ARPDAU_net_pln: 0.15,
                    wavg_conversion_rate: 0.0319,
                },
                {
                    date: '2025-08-18',
                    sum_daily_active_users: 250919,
                    new_users: 14608,
                    revenue_gross_usd: 88284.78,
                    inapp_revenue_gross_usd: 78042.84,
                    ad_revenue_gross_usd: 10241.94,
                    revenue_gross_pln: 321546.17,
                    inapp_revenue_gross_pln: 284243.99,
                    ad_revenue_gross_pln: 37302.18,
                    revenue_net_usd: 60876,
                    inapp_revenue_net_usd: 50634.07,
                    ad_revenue_net_usd: 10241.94,
                    revenue_net_pln: 221719.4,
                    inapp_revenue_net_pln: 184417.22,
                    ad_revenue_net_pln: 37302.18,
                    cnt_first_transaction: 1277,
                    transactions: 11160,
                    wavg_ARPDAU_gross_usd: 0.35,
                    inapp_wavg_ARPDAU_gross_usd: 0.31,
                    ad_wavg_ARPDAU_gross_usd: 0.04,
                    wavg_ARPDAU_gross_pln: 1.28,
                    inapp_wavg_ARPDAU_gross_pln: 1.13,
                    ad_wavg_ARPDAU_gross_pln: 0.15,
                    wavg_ARPDAU_net_usd: 0.24,
                    inapp_wavg_ARPDAU_net_usd: 0.2,
                    ad_wavg_ARPDAU_net_usd: 0.04,
                    wavg_ARPDAU_net_pln: 0.88,
                    inapp_wavg_ARPDAU_net_pln: 0.73,
                    ad_wavg_ARPDAU_net_pln: 0.15,
                    wavg_conversion_rate: 0.0295,
                },
                {
                    date: '2025-08-19',
                    sum_daily_active_users: 254626,
                    new_users: 16437,
                    revenue_gross_usd: 85683.35,
                    inapp_revenue_gross_usd: 75205.34,
                    ad_revenue_gross_usd: 10478.01,
                    revenue_gross_pln: 312390.38,
                    inapp_revenue_gross_pln: 274188.94,
                    ad_revenue_gross_pln: 38201.44,
                    revenue_net_usd: 59209.65,
                    inapp_revenue_net_usd: 48731.64,
                    ad_revenue_net_usd: 10478.01,
                    revenue_net_pln: 215870.7,
                    inapp_revenue_net_pln: 177669.26,
                    ad_revenue_net_pln: 38201.44,
                    cnt_first_transaction: 1322,
                    transactions: 10803,
                    wavg_ARPDAU_gross_usd: 0.34,
                    inapp_wavg_ARPDAU_gross_usd: 0.3,
                    ad_wavg_ARPDAU_gross_usd: 0.04,
                    wavg_ARPDAU_gross_pln: 1.23,
                    inapp_wavg_ARPDAU_gross_pln: 1.08,
                    ad_wavg_ARPDAU_gross_pln: 0.15,
                    wavg_ARPDAU_net_usd: 0.23,
                    inapp_wavg_ARPDAU_net_usd: 0.19,
                    ad_wavg_ARPDAU_net_usd: 0.04,
                    wavg_ARPDAU_net_pln: 0.85,
                    inapp_wavg_ARPDAU_net_pln: 0.7,
                    ad_wavg_ARPDAU_net_pln: 0.15,
                    wavg_conversion_rate: 0.0281,
                },
                {
                    date: '2025-08-20',
                    sum_daily_active_users: 254535,
                    new_users: 15556,
                    revenue_gross_usd: 85316.28,
                    inapp_revenue_gross_usd: 75031.86,
                    ad_revenue_gross_usd: 10284.42,
                    revenue_gross_pln: 311097.02,
                    inapp_revenue_gross_pln: 273597.49,
                    ad_revenue_gross_pln: 37499.53,
                    revenue_net_usd: 58780.33,
                    inapp_revenue_net_usd: 48495.9,
                    ad_revenue_net_usd: 10284.42,
                    revenue_net_pln: 214336.33,
                    inapp_revenue_net_pln: 176836.79,
                    ad_revenue_net_pln: 37499.53,
                    cnt_first_transaction: 1299,
                    transactions: 10653,
                    wavg_ARPDAU_gross_usd: 0.34,
                    inapp_wavg_ARPDAU_gross_usd: 0.29,
                    ad_wavg_ARPDAU_gross_usd: 0.04,
                    wavg_ARPDAU_gross_pln: 1.22,
                    inapp_wavg_ARPDAU_gross_pln: 1.07,
                    ad_wavg_ARPDAU_gross_pln: 0.15,
                    wavg_ARPDAU_net_usd: 0.23,
                    inapp_wavg_ARPDAU_net_usd: 0.19,
                    ad_wavg_ARPDAU_net_usd: 0.04,
                    wavg_ARPDAU_net_pln: 0.84,
                    inapp_wavg_ARPDAU_net_pln: 0.69,
                    ad_wavg_ARPDAU_net_pln: 0.15,
                    wavg_conversion_rate: 0.028,
                },
                {
                    date: '2025-08-21',
                    sum_daily_active_users: 256825,
                    new_users: 18698,
                    revenue_gross_usd: 83001.27,
                    inapp_revenue_gross_usd: 72822.84,
                    ad_revenue_gross_usd: 10178.43,
                    revenue_gross_pln: 304090.49,
                    inapp_revenue_gross_pln: 266796.37,
                    ad_revenue_gross_pln: 37294.12,
                    revenue_net_usd: 57492.9,
                    inapp_revenue_net_usd: 47314.47,
                    ad_revenue_net_usd: 10178.43,
                    revenue_net_pln: 210636.2,
                    inapp_revenue_net_pln: 173342.08,
                    ad_revenue_net_pln: 37294.12,
                    cnt_first_transaction: 1250,
                    transactions: 10600,
                    wavg_ARPDAU_gross_usd: 0.32,
                    inapp_wavg_ARPDAU_gross_usd: 0.28,
                    ad_wavg_ARPDAU_gross_usd: 0.04,
                    wavg_ARPDAU_gross_pln: 1.18,
                    inapp_wavg_ARPDAU_gross_pln: 1.04,
                    ad_wavg_ARPDAU_gross_pln: 0.15,
                    wavg_ARPDAU_net_usd: 0.22,
                    inapp_wavg_ARPDAU_net_usd: 0.18,
                    ad_wavg_ARPDAU_net_usd: 0.04,
                    wavg_ARPDAU_net_pln: 0.82,
                    inapp_wavg_ARPDAU_net_pln: 0.67,
                    ad_wavg_ARPDAU_net_pln: 0.15,
                    wavg_conversion_rate: 0.0272,
                },
                {
                    date: '2025-08-22',
                    sum_daily_active_users: 254586,
                    new_users: 18160,
                    revenue_gross_usd: 84252.12,
                    inapp_revenue_gross_usd: 74204.43,
                    ad_revenue_gross_usd: 10047.69,
                    revenue_gross_pln: 306603.42,
                    inapp_revenue_gross_pln: 270038.69,
                    ad_revenue_gross_pln: 36564.73,
                    revenue_net_usd: 58340.95,
                    inapp_revenue_net_usd: 48293.26,
                    ad_revenue_net_usd: 10047.69,
                    revenue_net_pln: 212309.61,
                    inapp_revenue_net_pln: 175744.88,
                    ad_revenue_net_pln: 36564.73,
                    cnt_first_transaction: 1281,
                    transactions: 10805,
                    wavg_ARPDAU_gross_usd: 0.33,
                    inapp_wavg_ARPDAU_gross_usd: 0.29,
                    ad_wavg_ARPDAU_gross_usd: 0.04,
                    wavg_ARPDAU_gross_pln: 1.2,
                    inapp_wavg_ARPDAU_gross_pln: 1.06,
                    ad_wavg_ARPDAU_gross_pln: 0.14,
                    wavg_ARPDAU_net_usd: 0.23,
                    inapp_wavg_ARPDAU_net_usd: 0.19,
                    ad_wavg_ARPDAU_net_usd: 0.04,
                    wavg_ARPDAU_net_pln: 0.83,
                    inapp_wavg_ARPDAU_net_pln: 0.69,
                    ad_wavg_ARPDAU_net_pln: 0.14,
                    wavg_conversion_rate: 0.0281,
                },
                {
                    date: '2025-08-23',
                    sum_daily_active_users: 252320,
                    new_users: 18446,
                    revenue_gross_usd: 83604.25,
                    inapp_revenue_gross_usd: 73649.57,
                    ad_revenue_gross_usd: 9954.68,
                    revenue_gross_pln: 304239.19,
                    inapp_revenue_gross_pln: 268013.68,
                    ad_revenue_gross_pln: 36225.51,
                    revenue_net_usd: 57773.91,
                    inapp_revenue_net_usd: 47819.23,
                    ad_revenue_net_usd: 9954.68,
                    revenue_net_pln: 210241.57,
                    inapp_revenue_net_pln: 174016.07,
                    ad_revenue_net_pln: 36225.51,
                    cnt_first_transaction: 1372,
                    transactions: 10806,
                    wavg_ARPDAU_gross_usd: 0.33,
                    inapp_wavg_ARPDAU_gross_usd: 0.29,
                    ad_wavg_ARPDAU_gross_usd: 0.04,
                    wavg_ARPDAU_gross_pln: 1.21,
                    inapp_wavg_ARPDAU_gross_pln: 1.06,
                    ad_wavg_ARPDAU_gross_pln: 0.14,
                    wavg_ARPDAU_net_usd: 0.23,
                    inapp_wavg_ARPDAU_net_usd: 0.19,
                    ad_wavg_ARPDAU_net_usd: 0.04,
                    wavg_ARPDAU_net_pln: 0.83,
                    inapp_wavg_ARPDAU_net_pln: 0.69,
                    ad_wavg_ARPDAU_net_pln: 0.14,
                    wavg_conversion_rate: 0.0283,
                },
                {
                    date: '2025-08-24',
                    sum_daily_active_users: 263286,
                    new_users: 20660,
                    revenue_gross_usd: 88302.1,
                    inapp_revenue_gross_usd: 77868.28,
                    ad_revenue_gross_usd: 10433.82,
                    revenue_gross_pln: 321367.26,
                    inapp_revenue_gross_pln: 283397.84,
                    ad_revenue_gross_pln: 37969.42,
                    revenue_net_usd: 61054.65,
                    inapp_revenue_net_usd: 50620.83,
                    ad_revenue_net_usd: 10433.82,
                    revenue_net_pln: 222202.72,
                    inapp_revenue_net_pln: 184233.31,
                    ad_revenue_net_pln: 37969.42,
                    cnt_first_transaction: 1615,
                    transactions: 11582,
                    wavg_ARPDAU_gross_usd: 0.34,
                    inapp_wavg_ARPDAU_gross_usd: 0.3,
                    ad_wavg_ARPDAU_gross_usd: 0.04,
                    wavg_ARPDAU_gross_pln: 1.22,
                    inapp_wavg_ARPDAU_gross_pln: 1.08,
                    ad_wavg_ARPDAU_gross_pln: 0.14,
                    wavg_ARPDAU_net_usd: 0.23,
                    inapp_wavg_ARPDAU_net_usd: 0.19,
                    ad_wavg_ARPDAU_net_usd: 0.04,
                    wavg_ARPDAU_net_pln: 0.84,
                    inapp_wavg_ARPDAU_net_pln: 0.7,
                    ad_wavg_ARPDAU_net_pln: 0.14,
                    wavg_conversion_rate: 0.0289,
                },
                {
                    date: '2025-08-25',
                    sum_daily_active_users: 262922,
                    new_users: 19323,
                    revenue_gross_usd: 82899.25,
                    inapp_revenue_gross_usd: 72855.29,
                    ad_revenue_gross_usd: 10043.96,
                    revenue_gross_pln: 304120.19,
                    inapp_revenue_gross_pln: 267272.02,
                    ad_revenue_gross_pln: 36848.17,
                    revenue_net_usd: 57403.99,
                    inapp_revenue_net_usd: 47360.03,
                    ad_revenue_net_usd: 10043.96,
                    revenue_net_pln: 210589.52,
                    inapp_revenue_net_pln: 173741.35,
                    ad_revenue_net_pln: 36848.17,
                    cnt_first_transaction: 1372,
                    transactions: 10735,
                    wavg_ARPDAU_gross_usd: 0.32,
                    inapp_wavg_ARPDAU_gross_usd: 0.28,
                    ad_wavg_ARPDAU_gross_usd: 0.04,
                    wavg_ARPDAU_gross_pln: 1.16,
                    inapp_wavg_ARPDAU_gross_pln: 1.02,
                    ad_wavg_ARPDAU_gross_pln: 0.14,
                    wavg_ARPDAU_net_usd: 0.22,
                    inapp_wavg_ARPDAU_net_usd: 0.18,
                    ad_wavg_ARPDAU_net_usd: 0.04,
                    wavg_ARPDAU_net_pln: 0.8,
                    inapp_wavg_ARPDAU_net_pln: 0.66,
                    ad_wavg_ARPDAU_net_pln: 0.14,
                    wavg_conversion_rate: 0.0271,
                },
                {
                    date: '2025-08-26',
                    sum_daily_active_users: 265234,
                    new_users: 19269,
                    revenue_gross_usd: 80556.07,
                    inapp_revenue_gross_usd: 70529.89,
                    ad_revenue_gross_usd: 10026.18,
                    revenue_gross_pln: 294763.09,
                    inapp_revenue_gross_pln: 258077.05,
                    ad_revenue_gross_pln: 36686.05,
                    revenue_net_usd: 55840.45,
                    inapp_revenue_net_usd: 45814.27,
                    ad_revenue_net_usd: 10026.18,
                    revenue_net_pln: 204326.11,
                    inapp_revenue_net_pln: 167640.06,
                    ad_revenue_net_pln: 36686.05,
                    cnt_first_transaction: 1340,
                    transactions: 10375,
                    wavg_ARPDAU_gross_usd: 0.3,
                    inapp_wavg_ARPDAU_gross_usd: 0.27,
                    ad_wavg_ARPDAU_gross_usd: 0.04,
                    wavg_ARPDAU_gross_pln: 1.11,
                    inapp_wavg_ARPDAU_gross_pln: 0.97,
                    ad_wavg_ARPDAU_gross_pln: 0.14,
                    wavg_ARPDAU_net_usd: 0.21,
                    inapp_wavg_ARPDAU_net_usd: 0.17,
                    ad_wavg_ARPDAU_net_usd: 0.04,
                    wavg_ARPDAU_net_pln: 0.77,
                    inapp_wavg_ARPDAU_net_pln: 0.63,
                    ad_wavg_ARPDAU_net_pln: 0.14,
                    wavg_conversion_rate: 0.0261,
                },
                {
                    date: '2025-08-27',
                    sum_daily_active_users: 260733,
                    new_users: 14633,
                    revenue_gross_usd: 81910.92,
                    inapp_revenue_gross_usd: 71955.04,
                    ad_revenue_gross_usd: 9955.88,
                    revenue_gross_pln: 300128.75,
                    inapp_revenue_gross_pln: 263646.88,
                    ad_revenue_gross_pln: 36481.86,
                    revenue_net_usd: 56608.79,
                    inapp_revenue_net_usd: 46652.92,
                    ad_revenue_net_usd: 9955.88,
                    revenue_net_pln: 207419.91,
                    inapp_revenue_net_pln: 170938.05,
                    ad_revenue_net_pln: 36481.86,
                    cnt_first_transaction: 1227,
                    transactions: 10324,
                    wavg_ARPDAU_gross_usd: 0.31,
                    inapp_wavg_ARPDAU_gross_usd: 0.28,
                    ad_wavg_ARPDAU_gross_usd: 0.04,
                    wavg_ARPDAU_gross_pln: 1.15,
                    inapp_wavg_ARPDAU_gross_pln: 1.01,
                    ad_wavg_ARPDAU_gross_pln: 0.14,
                    wavg_ARPDAU_net_usd: 0.22,
                    inapp_wavg_ARPDAU_net_usd: 0.18,
                    ad_wavg_ARPDAU_net_usd: 0.04,
                    wavg_ARPDAU_net_pln: 0.8,
                    inapp_wavg_ARPDAU_net_pln: 0.66,
                    ad_wavg_ARPDAU_net_pln: 0.14,
                    wavg_conversion_rate: 0.0261,
                },
                {
                    date: '2025-08-28',
                    sum_daily_active_users: 259520,
                    new_users: 14620,
                    revenue_gross_usd: 85055.32,
                    inapp_revenue_gross_usd: 75479.36,
                    ad_revenue_gross_usd: 9575.97,
                    revenue_gross_pln: 310310.87,
                    inapp_revenue_gross_pln: 275374.55,
                    ad_revenue_gross_pln: 34936.31,
                    revenue_net_usd: 58579.91,
                    inapp_revenue_net_usd: 49003.95,
                    ad_revenue_net_usd: 9575.97,
                    revenue_net_pln: 213719.53,
                    inapp_revenue_net_pln: 178783.22,
                    ad_revenue_net_pln: 34936.31,
                    cnt_first_transaction: 1326,
                    transactions: 10822,
                    wavg_ARPDAU_gross_usd: 0.33,
                    inapp_wavg_ARPDAU_gross_usd: 0.29,
                    ad_wavg_ARPDAU_gross_usd: 0.04,
                    wavg_ARPDAU_gross_pln: 1.2,
                    inapp_wavg_ARPDAU_gross_pln: 1.06,
                    ad_wavg_ARPDAU_gross_pln: 0.13,
                    wavg_ARPDAU_net_usd: 0.23,
                    inapp_wavg_ARPDAU_net_usd: 0.19,
                    ad_wavg_ARPDAU_net_usd: 0.04,
                    wavg_ARPDAU_net_pln: 0.82,
                    inapp_wavg_ARPDAU_net_pln: 0.69,
                    ad_wavg_ARPDAU_net_pln: 0.13,
                    wavg_conversion_rate: 0.0276,
                },
                {
                    date: '2025-08-29',
                    sum_daily_active_users: 255255,
                    new_users: 14119,
                    revenue_gross_usd: 104455.87,
                    inapp_revenue_gross_usd: 94913.1,
                    ad_revenue_gross_usd: 9542.78,
                    revenue_gross_pln: 381144.53,
                    inapp_revenue_gross_pln: 346324.31,
                    ad_revenue_gross_pln: 34820.22,
                    revenue_net_usd: 71041.45,
                    inapp_revenue_net_usd: 61498.68,
                    ad_revenue_net_usd: 9542.78,
                    revenue_net_pln: 259220.09,
                    inapp_revenue_net_pln: 224399.87,
                    ad_revenue_net_pln: 34820.22,
                    cnt_first_transaction: 1310,
                    transactions: 12707,
                    wavg_ARPDAU_gross_usd: 0.41,
                    inapp_wavg_ARPDAU_gross_usd: 0.37,
                    ad_wavg_ARPDAU_gross_usd: 0.04,
                    wavg_ARPDAU_gross_pln: 1.49,
                    inapp_wavg_ARPDAU_gross_pln: 1.36,
                    ad_wavg_ARPDAU_gross_pln: 0.14,
                    wavg_ARPDAU_net_usd: 0.28,
                    inapp_wavg_ARPDAU_net_usd: 0.24,
                    ad_wavg_ARPDAU_net_usd: 0.04,
                    wavg_ARPDAU_net_pln: 1.02,
                    inapp_wavg_ARPDAU_net_pln: 0.88,
                    ad_wavg_ARPDAU_net_pln: 0.14,
                    wavg_conversion_rate: 0.0345,
                },
                {
                    date: '2025-08-30',
                    sum_daily_active_users: 251675,
                    new_users: 15010,
                    revenue_gross_usd: 96692.16,
                    inapp_revenue_gross_usd: 86951.32,
                    ad_revenue_gross_usd: 9740.84,
                    revenue_gross_pln: 352818.1,
                    inapp_revenue_gross_pln: 317274.65,
                    ad_revenue_gross_pln: 35543.46,
                    revenue_net_usd: 65998.02,
                    inapp_revenue_net_usd: 56257.17,
                    ad_revenue_net_usd: 9740.84,
                    revenue_net_pln: 240818.81,
                    inapp_revenue_net_pln: 205275.36,
                    ad_revenue_net_pln: 35543.46,
                    cnt_first_transaction: 1353,
                    transactions: 11983,
                    wavg_ARPDAU_gross_usd: 0.38,
                    inapp_wavg_ARPDAU_gross_usd: 0.35,
                    ad_wavg_ARPDAU_gross_usd: 0.04,
                    wavg_ARPDAU_gross_pln: 1.4,
                    inapp_wavg_ARPDAU_gross_pln: 1.26,
                    ad_wavg_ARPDAU_gross_pln: 0.14,
                    wavg_ARPDAU_net_usd: 0.26,
                    inapp_wavg_ARPDAU_net_usd: 0.22,
                    ad_wavg_ARPDAU_net_usd: 0.04,
                    wavg_ARPDAU_net_pln: 0.96,
                    inapp_wavg_ARPDAU_net_pln: 0.82,
                    ad_wavg_ARPDAU_net_pln: 0.14,
                    wavg_conversion_rate: 0.0327,
                },
                {
                    date: '2025-08-31',
                    sum_daily_active_users: 261488,
                    new_users: 17839,
                    revenue_gross_usd: 102917.74,
                    inapp_revenue_gross_usd: 92520.09,
                    ad_revenue_gross_usd: 10397.65,
                    revenue_gross_pln: 375255.5,
                    inapp_revenue_gross_pln: 337342.89,
                    ad_revenue_gross_pln: 37912.6,
                    revenue_net_usd: 70151.15,
                    inapp_revenue_net_usd: 59753.5,
                    ad_revenue_net_usd: 10397.65,
                    revenue_net_pln: 255782.85,
                    inapp_revenue_net_pln: 217870.24,
                    ad_revenue_net_pln: 37912.6,
                    cnt_first_transaction: 1564,
                    transactions: 12875,
                    wavg_ARPDAU_gross_usd: 0.39,
                    inapp_wavg_ARPDAU_gross_usd: 0.35,
                    ad_wavg_ARPDAU_gross_usd: 0.04,
                    wavg_ARPDAU_gross_pln: 1.44,
                    inapp_wavg_ARPDAU_gross_pln: 1.29,
                    ad_wavg_ARPDAU_gross_pln: 0.14,
                    wavg_ARPDAU_net_usd: 0.27,
                    inapp_wavg_ARPDAU_net_usd: 0.23,
                    ad_wavg_ARPDAU_net_usd: 0.04,
                    wavg_ARPDAU_net_pln: 0.98,
                    inapp_wavg_ARPDAU_net_pln: 0.83,
                    ad_wavg_ARPDAU_net_pln: 0.14,
                    wavg_conversion_rate: 0.0334,
                },
                {
                    date: '2025-09-01',
                    sum_daily_active_users: 260312,
                    new_users: 16623,
                    revenue_gross_usd: 99663.68,
                    inapp_revenue_gross_usd: 89895.64,
                    ad_revenue_gross_usd: 9768.04,
                    revenue_gross_pln: 362640.85,
                    inapp_revenue_gross_pln: 327101.66,
                    ad_revenue_gross_pln: 35539.19,
                    revenue_net_usd: 68073.02,
                    inapp_revenue_net_usd: 58304.98,
                    ad_revenue_net_usd: 9768.04,
                    revenue_net_pln: 247694.21,
                    inapp_revenue_net_pln: 212155.01,
                    ad_revenue_net_pln: 35539.19,
                    cnt_first_transaction: 1321,
                    transactions: 12110,
                    wavg_ARPDAU_gross_usd: 0.38,
                    inapp_wavg_ARPDAU_gross_usd: 0.35,
                    ad_wavg_ARPDAU_gross_usd: 0.04,
                    wavg_ARPDAU_gross_pln: 1.39,
                    inapp_wavg_ARPDAU_gross_pln: 1.26,
                    ad_wavg_ARPDAU_gross_pln: 0.14,
                    wavg_ARPDAU_net_usd: 0.26,
                    inapp_wavg_ARPDAU_net_usd: 0.22,
                    ad_wavg_ARPDAU_net_usd: 0.04,
                    wavg_ARPDAU_net_pln: 0.95,
                    inapp_wavg_ARPDAU_net_pln: 0.82,
                    ad_wavg_ARPDAU_net_pln: 0.14,
                    wavg_conversion_rate: 0.0315,
                },
                {
                    date: '2025-09-02',
                    sum_daily_active_users: 261525,
                    new_users: 17070,
                    revenue_gross_usd: 90822.74,
                    inapp_revenue_gross_usd: 81162.36,
                    ad_revenue_gross_usd: 9660.38,
                    revenue_gross_pln: 332865.33,
                    inapp_revenue_gross_pln: 297457.95,
                    ad_revenue_gross_pln: 35407.38,
                    revenue_net_usd: 62284.39,
                    inapp_revenue_net_usd: 52624.01,
                    ad_revenue_net_usd: 9660.38,
                    revenue_net_pln: 228272.07,
                    inapp_revenue_net_pln: 192864.69,
                    ad_revenue_net_pln: 35407.38,
                    cnt_first_transaction: 1235,
                    transactions: 11088,
                    wavg_ARPDAU_gross_usd: 0.35,
                    inapp_wavg_ARPDAU_gross_usd: 0.31,
                    ad_wavg_ARPDAU_gross_usd: 0.04,
                    wavg_ARPDAU_gross_pln: 1.27,
                    inapp_wavg_ARPDAU_gross_pln: 1.14,
                    ad_wavg_ARPDAU_gross_pln: 0.14,
                    wavg_ARPDAU_net_usd: 0.24,
                    inapp_wavg_ARPDAU_net_usd: 0.2,
                    ad_wavg_ARPDAU_net_usd: 0.04,
                    wavg_ARPDAU_net_pln: 0.87,
                    inapp_wavg_ARPDAU_net_pln: 0.74,
                    ad_wavg_ARPDAU_net_pln: 0.14,
                    wavg_conversion_rate: 0.0289,
                },
                {
                    date: '2025-09-03',
                    sum_daily_active_users: 258517,
                    new_users: 15140,
                    revenue_gross_usd: 88636.02,
                    inapp_revenue_gross_usd: 79183.74,
                    ad_revenue_gross_usd: 9452.29,
                    revenue_gross_pln: 323300.47,
                    inapp_revenue_gross_pln: 288823.16,
                    ad_revenue_gross_pln: 34477.3,
                    revenue_net_usd: 60623.05,
                    inapp_revenue_net_usd: 51170.76,
                    ad_revenue_net_usd: 9452.29,
                    revenue_net_pln: 221122.95,
                    inapp_revenue_net_pln: 186645.64,
                    ad_revenue_net_pln: 34477.3,
                    cnt_first_transaction: 1164,
                    transactions: 10963,
                    wavg_ARPDAU_gross_usd: 0.34,
                    inapp_wavg_ARPDAU_gross_usd: 0.31,
                    ad_wavg_ARPDAU_gross_usd: 0.04,
                    wavg_ARPDAU_gross_pln: 1.25,
                    inapp_wavg_ARPDAU_gross_pln: 1.12,
                    ad_wavg_ARPDAU_gross_pln: 0.13,
                    wavg_ARPDAU_net_usd: 0.23,
                    inapp_wavg_ARPDAU_net_usd: 0.2,
                    ad_wavg_ARPDAU_net_usd: 0.04,
                    wavg_ARPDAU_net_pln: 0.86,
                    inapp_wavg_ARPDAU_net_pln: 0.72,
                    ad_wavg_ARPDAU_net_pln: 0.13,
                    wavg_conversion_rate: 0.0288,
                },
                {
                    date: '2025-09-04',
                    sum_daily_active_users: 256277,
                    new_users: 14394,
                    revenue_gross_usd: 87079.63,
                    inapp_revenue_gross_usd: 77902.45,
                    ad_revenue_gross_usd: 9177.18,
                    revenue_gross_pln: 317534.38,
                    inapp_revenue_gross_pln: 284067.37,
                    ad_revenue_gross_pln: 33467.01,
                    revenue_net_usd: 59722.71,
                    inapp_revenue_net_usd: 50545.52,
                    ad_revenue_net_usd: 9177.18,
                    revenue_net_pln: 217777.69,
                    inapp_revenue_net_pln: 184310.68,
                    ad_revenue_net_pln: 33467.01,
                    cnt_first_transaction: 1187,
                    transactions: 10820,
                    wavg_ARPDAU_gross_usd: 0.34,
                    inapp_wavg_ARPDAU_gross_usd: 0.3,
                    ad_wavg_ARPDAU_gross_usd: 0.04,
                    wavg_ARPDAU_gross_pln: 1.24,
                    inapp_wavg_ARPDAU_gross_pln: 1.11,
                    ad_wavg_ARPDAU_gross_pln: 0.13,
                    wavg_ARPDAU_net_usd: 0.23,
                    inapp_wavg_ARPDAU_net_usd: 0.2,
                    ad_wavg_ARPDAU_net_usd: 0.04,
                    wavg_ARPDAU_net_pln: 0.85,
                    inapp_wavg_ARPDAU_net_pln: 0.72,
                    ad_wavg_ARPDAU_net_pln: 0.13,
                    wavg_conversion_rate: 0.0293,
                },
                {
                    date: '2025-09-05',
                    sum_daily_active_users: 255495,
                    new_users: 16538,
                    revenue_gross_usd: 89870.27,
                    inapp_revenue_gross_usd: 80914.23,
                    ad_revenue_gross_usd: 8956.04,
                    revenue_gross_pln: 325907.93,
                    inapp_revenue_gross_pln: 293429.52,
                    ad_revenue_gross_pln: 32478.41,
                    revenue_net_usd: 61454.5,
                    inapp_revenue_net_usd: 52498.45,
                    ad_revenue_net_usd: 8956.04,
                    revenue_net_pln: 222860.21,
                    inapp_revenue_net_pln: 190381.81,
                    ad_revenue_net_pln: 32478.41,
                    cnt_first_transaction: 1280,
                    transactions: 11046,
                    wavg_ARPDAU_gross_usd: 0.35,
                    inapp_wavg_ARPDAU_gross_usd: 0.32,
                    ad_wavg_ARPDAU_gross_usd: 0.04,
                    wavg_ARPDAU_gross_pln: 1.28,
                    inapp_wavg_ARPDAU_gross_pln: 1.15,
                    ad_wavg_ARPDAU_gross_pln: 0.13,
                    wavg_ARPDAU_net_usd: 0.24,
                    inapp_wavg_ARPDAU_net_usd: 0.21,
                    ad_wavg_ARPDAU_net_usd: 0.04,
                    wavg_ARPDAU_net_pln: 0.87,
                    inapp_wavg_ARPDAU_net_pln: 0.75,
                    ad_wavg_ARPDAU_net_pln: 0.13,
                    wavg_conversion_rate: 0.03,
                },
                {
                    date: '2025-09-06',
                    sum_daily_active_users: 256147,
                    new_users: 19805,
                    revenue_gross_usd: 93683.41,
                    inapp_revenue_gross_usd: 84597.61,
                    ad_revenue_gross_usd: 9085.8,
                    revenue_gross_pln: 339777.79,
                    inapp_revenue_gross_pln: 306825.25,
                    ad_revenue_gross_pln: 32952.54,
                    revenue_net_usd: 64041.29,
                    inapp_revenue_net_usd: 54955.49,
                    ad_revenue_net_usd: 9085.8,
                    revenue_net_pln: 232269.69,
                    inapp_revenue_net_pln: 199317.15,
                    ad_revenue_net_pln: 32952.54,
                    cnt_first_transaction: 1521,
                    transactions: 11753,
                    wavg_ARPDAU_gross_usd: 0.37,
                    inapp_wavg_ARPDAU_gross_usd: 0.33,
                    ad_wavg_ARPDAU_gross_usd: 0.04,
                    wavg_ARPDAU_gross_pln: 1.33,
                    inapp_wavg_ARPDAU_gross_pln: 1.2,
                    ad_wavg_ARPDAU_gross_pln: 0.13,
                    wavg_ARPDAU_net_usd: 0.25,
                    inapp_wavg_ARPDAU_net_usd: 0.21,
                    ad_wavg_ARPDAU_net_usd: 0.04,
                    wavg_ARPDAU_net_pln: 0.91,
                    inapp_wavg_ARPDAU_net_pln: 0.78,
                    ad_wavg_ARPDAU_net_pln: 0.13,
                    wavg_conversion_rate: 0.0313,
                },
                {
                    date: '2025-09-07',
                    sum_daily_active_users: 267469,
                    new_users: 21520,
                    revenue_gross_usd: 99040.04,
                    inapp_revenue_gross_usd: 89010.61,
                    ad_revenue_gross_usd: 10029.43,
                    revenue_gross_pln: 359616.2,
                    inapp_revenue_gross_pln: 323196.5,
                    ad_revenue_gross_pln: 36419.7,
                    revenue_net_usd: 67706.52,
                    inapp_revenue_net_usd: 57677.09,
                    ad_revenue_net_usd: 10029.43,
                    revenue_net_pln: 245843.65,
                    inapp_revenue_net_pln: 209423.95,
                    ad_revenue_net_pln: 36419.7,
                    cnt_first_transaction: 1697,
                    transactions: 12727,
                    wavg_ARPDAU_gross_usd: 0.37,
                    inapp_wavg_ARPDAU_gross_usd: 0.33,
                    ad_wavg_ARPDAU_gross_usd: 0.04,
                    wavg_ARPDAU_gross_pln: 1.34,
                    inapp_wavg_ARPDAU_gross_pln: 1.21,
                    ad_wavg_ARPDAU_gross_pln: 0.14,
                    wavg_ARPDAU_net_usd: 0.25,
                    inapp_wavg_ARPDAU_net_usd: 0.22,
                    ad_wavg_ARPDAU_net_usd: 0.04,
                    wavg_ARPDAU_net_pln: 0.92,
                    inapp_wavg_ARPDAU_net_pln: 0.78,
                    ad_wavg_ARPDAU_net_pln: 0.14,
                    wavg_conversion_rate: 0.0319,
                },
                {
                    date: '2025-09-08',
                    sum_daily_active_users: 264396,
                    new_users: 18293,
                    revenue_gross_usd: 90740.33,
                    inapp_revenue_gross_usd: 81192.84,
                    ad_revenue_gross_usd: 9547.48,
                    revenue_gross_pln: 327754.72,
                    inapp_revenue_gross_pln: 293271.06,
                    ad_revenue_gross_pln: 34483.66,
                    revenue_net_usd: 62158.67,
                    inapp_revenue_net_usd: 52611.19,
                    ad_revenue_net_usd: 9547.48,
                    revenue_net_pln: 224517.9,
                    inapp_revenue_net_pln: 190034.24,
                    ad_revenue_net_pln: 34483.66,
                    cnt_first_transaction: 1483,
                    transactions: 11428,
                    wavg_ARPDAU_gross_usd: 0.34,
                    inapp_wavg_ARPDAU_gross_usd: 0.31,
                    ad_wavg_ARPDAU_gross_usd: 0.04,
                    wavg_ARPDAU_gross_pln: 1.24,
                    inapp_wavg_ARPDAU_gross_pln: 1.11,
                    ad_wavg_ARPDAU_gross_pln: 0.13,
                    wavg_ARPDAU_net_usd: 0.24,
                    inapp_wavg_ARPDAU_net_usd: 0.2,
                    ad_wavg_ARPDAU_net_usd: 0.04,
                    wavg_ARPDAU_net_pln: 0.85,
                    inapp_wavg_ARPDAU_net_pln: 0.72,
                    ad_wavg_ARPDAU_net_pln: 0.13,
                    wavg_conversion_rate: 0.0287,
                },
                {
                    date: '2025-09-09',
                    sum_daily_active_users: 266682,
                    new_users: 18951,
                    revenue_gross_usd: 83688.47,
                    inapp_revenue_gross_usd: 73648.96,
                    ad_revenue_gross_usd: 10039.5,
                    revenue_gross_pln: 304055.13,
                    inapp_revenue_gross_pln: 267581.14,
                    ad_revenue_gross_pln: 36474,
                    revenue_net_usd: 57880.43,
                    inapp_revenue_net_usd: 47840.93,
                    ad_revenue_net_usd: 10039.5,
                    revenue_net_pln: 210289.92,
                    inapp_revenue_net_pln: 173815.93,
                    ad_revenue_net_pln: 36474,
                    cnt_first_transaction: 1417,
                    transactions: 10879,
                    wavg_ARPDAU_gross_usd: 0.31,
                    inapp_wavg_ARPDAU_gross_usd: 0.28,
                    ad_wavg_ARPDAU_gross_usd: 0.04,
                    wavg_ARPDAU_gross_pln: 1.14,
                    inapp_wavg_ARPDAU_gross_pln: 1,
                    ad_wavg_ARPDAU_gross_pln: 0.14,
                    wavg_ARPDAU_net_usd: 0.22,
                    inapp_wavg_ARPDAU_net_usd: 0.18,
                    ad_wavg_ARPDAU_net_usd: 0.04,
                    wavg_ARPDAU_net_pln: 0.79,
                    inapp_wavg_ARPDAU_net_pln: 0.65,
                    ad_wavg_ARPDAU_net_pln: 0.14,
                    wavg_conversion_rate: 0.0272,
                },
                {
                    date: '2025-09-10',
                    sum_daily_active_users: 266000,
                    new_users: 18178,
                    revenue_gross_usd: 81476.15,
                    inapp_revenue_gross_usd: 71704.91,
                    ad_revenue_gross_usd: 9771.24,
                    revenue_gross_pln: 296709.4,
                    inapp_revenue_gross_pln: 261123.88,
                    ad_revenue_gross_pln: 35585.51,
                    revenue_net_usd: 56219.85,
                    inapp_revenue_net_usd: 46448.61,
                    ad_revenue_net_usd: 9771.24,
                    revenue_net_pln: 204734.31,
                    inapp_revenue_net_pln: 169148.8,
                    ad_revenue_net_pln: 35585.51,
                    cnt_first_transaction: 1324,
                    transactions: 10584,
                    wavg_ARPDAU_gross_usd: 0.31,
                    inapp_wavg_ARPDAU_gross_usd: 0.27,
                    ad_wavg_ARPDAU_gross_usd: 0.04,
                    wavg_ARPDAU_gross_pln: 1.12,
                    inapp_wavg_ARPDAU_gross_pln: 0.98,
                    ad_wavg_ARPDAU_gross_pln: 0.13,
                    wavg_ARPDAU_net_usd: 0.21,
                    inapp_wavg_ARPDAU_net_usd: 0.17,
                    ad_wavg_ARPDAU_net_usd: 0.04,
                    wavg_ARPDAU_net_pln: 0.77,
                    inapp_wavg_ARPDAU_net_pln: 0.64,
                    ad_wavg_ARPDAU_net_pln: 0.13,
                    wavg_conversion_rate: 0.0272,
                },
                {
                    date: '2025-09-11',
                    sum_daily_active_users: 263145,
                    new_users: 16080,
                    revenue_gross_usd: 83545.12,
                    inapp_revenue_gross_usd: 74373.54,
                    ad_revenue_gross_usd: 9171.58,
                    revenue_gross_pln: 302914.07,
                    inapp_revenue_gross_pln: 269660.33,
                    ad_revenue_gross_pln: 33253.73,
                    revenue_net_usd: 57349.26,
                    inapp_revenue_net_usd: 48177.68,
                    ad_revenue_net_usd: 9171.58,
                    revenue_net_pln: 207934.33,
                    inapp_revenue_net_pln: 174680.59,
                    ad_revenue_net_pln: 33253.73,
                    cnt_first_transaction: 1295,
                    transactions: 10472,
                    wavg_ARPDAU_gross_usd: 0.32,
                    inapp_wavg_ARPDAU_gross_usd: 0.28,
                    ad_wavg_ARPDAU_gross_usd: 0.03,
                    wavg_ARPDAU_gross_pln: 1.15,
                    inapp_wavg_ARPDAU_gross_pln: 1.02,
                    ad_wavg_ARPDAU_gross_pln: 0.13,
                    wavg_ARPDAU_net_usd: 0.22,
                    inapp_wavg_ARPDAU_net_usd: 0.18,
                    ad_wavg_ARPDAU_net_usd: 0.03,
                    wavg_ARPDAU_net_pln: 0.79,
                    inapp_wavg_ARPDAU_net_pln: 0.66,
                    ad_wavg_ARPDAU_net_pln: 0.13,
                    wavg_conversion_rate: 0.0266,
                },
                {
                    date: '2025-09-12',
                    sum_daily_active_users: 260053,
                    new_users: 16037,
                    revenue_gross_usd: 81191.88,
                    inapp_revenue_gross_usd: 72127.18,
                    ad_revenue_gross_usd: 9064.7,
                    revenue_gross_pln: 294488.99,
                    inapp_revenue_gross_pln: 261610.72,
                    ad_revenue_gross_pln: 32878.28,
                    revenue_net_usd: 55997.31,
                    inapp_revenue_net_usd: 46932.61,
                    ad_revenue_net_usd: 9064.7,
                    revenue_net_pln: 203106.4,
                    inapp_revenue_net_pln: 170228.13,
                    ad_revenue_net_pln: 32878.28,
                    cnt_first_transaction: 1294,
                    transactions: 10572,
                    wavg_ARPDAU_gross_usd: 0.31,
                    inapp_wavg_ARPDAU_gross_usd: 0.28,
                    ad_wavg_ARPDAU_gross_usd: 0.03,
                    wavg_ARPDAU_gross_pln: 1.13,
                    inapp_wavg_ARPDAU_gross_pln: 1.01,
                    ad_wavg_ARPDAU_gross_pln: 0.13,
                    wavg_ARPDAU_net_usd: 0.22,
                    inapp_wavg_ARPDAU_net_usd: 0.18,
                    ad_wavg_ARPDAU_net_usd: 0.03,
                    wavg_ARPDAU_net_pln: 0.78,
                    inapp_wavg_ARPDAU_net_pln: 0.65,
                    ad_wavg_ARPDAU_net_pln: 0.13,
                    wavg_conversion_rate: 0.0269,
                },
                {
                    date: '2025-09-13',
                    sum_daily_active_users: 259221,
                    new_users: 16802,
                    revenue_gross_usd: 86382.67,
                    inapp_revenue_gross_usd: 76892.9,
                    ad_revenue_gross_usd: 9489.77,
                    revenue_gross_pln: 313369.45,
                    inapp_revenue_gross_pln: 278943.69,
                    ad_revenue_gross_pln: 34425.76,
                    revenue_net_usd: 59394.75,
                    inapp_revenue_net_usd: 49904.98,
                    ad_revenue_net_usd: 9489.77,
                    revenue_net_pln: 215465.68,
                    inapp_revenue_net_pln: 181039.91,
                    ad_revenue_net_pln: 34425.76,
                    cnt_first_transaction: 1381,
                    transactions: 10967,
                    wavg_ARPDAU_gross_usd: 0.33,
                    inapp_wavg_ARPDAU_gross_usd: 0.3,
                    ad_wavg_ARPDAU_gross_usd: 0.04,
                    wavg_ARPDAU_gross_pln: 1.21,
                    inapp_wavg_ARPDAU_gross_pln: 1.08,
                    ad_wavg_ARPDAU_gross_pln: 0.13,
                    wavg_ARPDAU_net_usd: 0.23,
                    inapp_wavg_ARPDAU_net_usd: 0.19,
                    ad_wavg_ARPDAU_net_usd: 0.04,
                    wavg_ARPDAU_net_pln: 0.83,
                    inapp_wavg_ARPDAU_net_pln: 0.7,
                    ad_wavg_ARPDAU_net_pln: 0.13,
                    wavg_conversion_rate: 0.0278,
                },
                {
                    date: '2025-09-14',
                    sum_daily_active_users: 268572,
                    new_users: 18073,
                    revenue_gross_usd: 92404.46,
                    inapp_revenue_gross_usd: 82275.21,
                    ad_revenue_gross_usd: 10129.25,
                    revenue_gross_pln: 335276.22,
                    inapp_revenue_gross_pln: 298521.11,
                    ad_revenue_gross_pln: 36755.11,
                    revenue_net_usd: 63493.42,
                    inapp_revenue_net_usd: 53364.17,
                    ad_revenue_net_usd: 10129.25,
                    revenue_net_pln: 230376.62,
                    inapp_revenue_net_pln: 193621.51,
                    ad_revenue_net_pln: 36755.11,
                    cnt_first_transaction: 1700,
                    transactions: 12067,
                    wavg_ARPDAU_gross_usd: 0.34,
                    inapp_wavg_ARPDAU_gross_usd: 0.31,
                    ad_wavg_ARPDAU_gross_usd: 0.04,
                    wavg_ARPDAU_gross_pln: 1.25,
                    inapp_wavg_ARPDAU_gross_pln: 1.11,
                    ad_wavg_ARPDAU_gross_pln: 0.14,
                    wavg_ARPDAU_net_usd: 0.24,
                    inapp_wavg_ARPDAU_net_usd: 0.2,
                    ad_wavg_ARPDAU_net_usd: 0.04,
                    wavg_ARPDAU_net_pln: 0.86,
                    inapp_wavg_ARPDAU_net_pln: 0.72,
                    ad_wavg_ARPDAU_net_pln: 0.14,
                    wavg_conversion_rate: 0.0293,
                },
                {
                    date: '2025-09-15',
                    sum_daily_active_users: 266336,
                    new_users: 16418,
                    revenue_gross_usd: 87203.49,
                    inapp_revenue_gross_usd: 77687.76,
                    ad_revenue_gross_usd: 9515.73,
                    revenue_gross_pln: 314822.83,
                    inapp_revenue_gross_pln: 280465.08,
                    ad_revenue_gross_pln: 34357.75,
                    revenue_net_usd: 59921.57,
                    inapp_revenue_net_usd: 50405.84,
                    ad_revenue_net_usd: 9515.73,
                    revenue_net_pln: 216329.44,
                    inapp_revenue_net_pln: 181971.69,
                    ad_revenue_net_pln: 34357.75,
                    cnt_first_transaction: 1411,
                    transactions: 11076,
                    wavg_ARPDAU_gross_usd: 0.33,
                    inapp_wavg_ARPDAU_gross_usd: 0.29,
                    ad_wavg_ARPDAU_gross_usd: 0.04,
                    wavg_ARPDAU_gross_pln: 1.18,
                    inapp_wavg_ARPDAU_gross_pln: 1.05,
                    ad_wavg_ARPDAU_gross_pln: 0.13,
                    wavg_ARPDAU_net_usd: 0.22,
                    inapp_wavg_ARPDAU_net_usd: 0.19,
                    ad_wavg_ARPDAU_net_usd: 0.04,
                    wavg_ARPDAU_net_pln: 0.81,
                    inapp_wavg_ARPDAU_net_pln: 0.68,
                    ad_wavg_ARPDAU_net_pln: 0.13,
                    wavg_conversion_rate: 0.0271,
                },
                {
                    date: '2025-09-16',
                    sum_daily_active_users: 268553,
                    new_users: 16680,
                    revenue_gross_usd: 85346.7,
                    inapp_revenue_gross_usd: 75802.37,
                    ad_revenue_gross_usd: 9544.33,
                    revenue_gross_pln: 305542,
                    inapp_revenue_gross_pln: 271375.56,
                    ad_revenue_gross_pln: 34166.43,
                    revenue_net_usd: 58710.61,
                    inapp_revenue_net_usd: 49166.29,
                    ad_revenue_net_usd: 9544.33,
                    revenue_net_pln: 210184.25,
                    inapp_revenue_net_pln: 176017.82,
                    ad_revenue_net_pln: 34166.43,
                    cnt_first_transaction: 1392,
                    transactions: 10907,
                    wavg_ARPDAU_gross_usd: 0.32,
                    inapp_wavg_ARPDAU_gross_usd: 0.28,
                    ad_wavg_ARPDAU_gross_usd: 0.04,
                    wavg_ARPDAU_gross_pln: 1.14,
                    inapp_wavg_ARPDAU_gross_pln: 1.01,
                    ad_wavg_ARPDAU_gross_pln: 0.13,
                    wavg_ARPDAU_net_usd: 0.22,
                    inapp_wavg_ARPDAU_net_usd: 0.18,
                    ad_wavg_ARPDAU_net_usd: 0.04,
                    wavg_ARPDAU_net_pln: 0.78,
                    inapp_wavg_ARPDAU_net_pln: 0.66,
                    ad_wavg_ARPDAU_net_pln: 0.13,
                    wavg_conversion_rate: 0.0273,
                },
                {
                    date: '2025-09-17',
                    sum_daily_active_users: 268602,
                    new_users: 16319,
                    revenue_gross_usd: 86364,
                    inapp_revenue_gross_usd: 76998.54,
                    ad_revenue_gross_usd: 9365.47,
                    revenue_gross_pln: 310788.2,
                    inapp_revenue_gross_pln: 277087.97,
                    ad_revenue_gross_pln: 33700.23,
                    revenue_net_usd: 59348.76,
                    inapp_revenue_net_usd: 49983.3,
                    ad_revenue_net_usd: 9365.47,
                    revenue_net_pln: 213571.41,
                    inapp_revenue_net_pln: 179871.18,
                    ad_revenue_net_pln: 33700.23,
                    cnt_first_transaction: 1347,
                    transactions: 10947,
                    wavg_ARPDAU_gross_usd: 0.32,
                    inapp_wavg_ARPDAU_gross_usd: 0.29,
                    ad_wavg_ARPDAU_gross_usd: 0.03,
                    wavg_ARPDAU_gross_pln: 1.16,
                    inapp_wavg_ARPDAU_gross_pln: 1.03,
                    ad_wavg_ARPDAU_gross_pln: 0.13,
                    wavg_ARPDAU_net_usd: 0.22,
                    inapp_wavg_ARPDAU_net_usd: 0.19,
                    ad_wavg_ARPDAU_net_usd: 0.03,
                    wavg_ARPDAU_net_pln: 0.8,
                    inapp_wavg_ARPDAU_net_pln: 0.67,
                    ad_wavg_ARPDAU_net_pln: 0.13,
                    wavg_conversion_rate: 0.0272,
                },
                {
                    date: '2025-09-18',
                    sum_daily_active_users: 270054,
                    new_users: 17133,
                    revenue_gross_usd: 85304.52,
                    inapp_revenue_gross_usd: 75961.62,
                    ad_revenue_gross_usd: 9342.9,
                    revenue_gross_pln: 308339.63,
                    inapp_revenue_gross_pln: 274570.37,
                    ad_revenue_gross_pln: 33769.26,
                    revenue_net_usd: 58634.07,
                    inapp_revenue_net_usd: 49291.16,
                    ad_revenue_net_usd: 9342.9,
                    revenue_net_pln: 211937.35,
                    inapp_revenue_net_pln: 178168.08,
                    ad_revenue_net_pln: 33769.26,
                    cnt_first_transaction: 1352,
                    transactions: 10932,
                    wavg_ARPDAU_gross_usd: 0.32,
                    inapp_wavg_ARPDAU_gross_usd: 0.28,
                    ad_wavg_ARPDAU_gross_usd: 0.03,
                    wavg_ARPDAU_gross_pln: 1.14,
                    inapp_wavg_ARPDAU_gross_pln: 1.02,
                    ad_wavg_ARPDAU_gross_pln: 0.13,
                    wavg_ARPDAU_net_usd: 0.22,
                    inapp_wavg_ARPDAU_net_usd: 0.18,
                    ad_wavg_ARPDAU_net_usd: 0.03,
                    wavg_ARPDAU_net_pln: 0.78,
                    inapp_wavg_ARPDAU_net_pln: 0.66,
                    ad_wavg_ARPDAU_net_pln: 0.13,
                    wavg_conversion_rate: 0.0273,
                },
                {
                    date: '2025-09-19',
                    sum_daily_active_users: 269238,
                    new_users: 19447,
                    revenue_gross_usd: 87956.08,
                    inapp_revenue_gross_usd: 78240.18,
                    ad_revenue_gross_usd: 9715.9,
                    revenue_gross_pln: 319259.81,
                    inapp_revenue_gross_pln: 283993.4,
                    ad_revenue_gross_pln: 35266.41,
                    revenue_net_usd: 60566.71,
                    inapp_revenue_net_usd: 50850.8,
                    ad_revenue_net_usd: 9715.9,
                    revenue_net_pln: 219842.85,
                    inapp_revenue_net_pln: 184576.44,
                    ad_revenue_net_pln: 35266.41,
                    cnt_first_transaction: 1321,
                    transactions: 11272,
                    wavg_ARPDAU_gross_usd: 0.33,
                    inapp_wavg_ARPDAU_gross_usd: 0.29,
                    ad_wavg_ARPDAU_gross_usd: 0.04,
                    wavg_ARPDAU_gross_pln: 1.19,
                    inapp_wavg_ARPDAU_gross_pln: 1.05,
                    ad_wavg_ARPDAU_gross_pln: 0.13,
                    wavg_ARPDAU_net_usd: 0.22,
                    inapp_wavg_ARPDAU_net_usd: 0.19,
                    ad_wavg_ARPDAU_net_usd: 0.04,
                    wavg_ARPDAU_net_pln: 0.82,
                    inapp_wavg_ARPDAU_net_pln: 0.69,
                    ad_wavg_ARPDAU_net_pln: 0.13,
                    wavg_conversion_rate: 0.0281,
                },
                {
                    date: '2025-09-20',
                    sum_daily_active_users: 267384,
                    new_users: 19158,
                    revenue_gross_usd: 89799.09,
                    inapp_revenue_gross_usd: 79848.73,
                    ad_revenue_gross_usd: 9950.36,
                    revenue_gross_pln: 325977.21,
                    inapp_revenue_gross_pln: 289856.69,
                    ad_revenue_gross_pln: 36120.52,
                    revenue_net_usd: 61795.39,
                    inapp_revenue_net_usd: 51845.04,
                    ad_revenue_net_usd: 9950.36,
                    revenue_net_pln: 224321.76,
                    inapp_revenue_net_pln: 188201.24,
                    ad_revenue_net_pln: 36120.52,
                    cnt_first_transaction: 1421,
                    transactions: 11378,
                    wavg_ARPDAU_gross_usd: 0.34,
                    inapp_wavg_ARPDAU_gross_usd: 0.3,
                    ad_wavg_ARPDAU_gross_usd: 0.04,
                    wavg_ARPDAU_gross_pln: 1.22,
                    inapp_wavg_ARPDAU_gross_pln: 1.08,
                    ad_wavg_ARPDAU_gross_pln: 0.14,
                    wavg_ARPDAU_net_usd: 0.23,
                    inapp_wavg_ARPDAU_net_usd: 0.19,
                    ad_wavg_ARPDAU_net_usd: 0.04,
                    wavg_ARPDAU_net_pln: 0.84,
                    inapp_wavg_ARPDAU_net_pln: 0.7,
                    ad_wavg_ARPDAU_net_pln: 0.14,
                    wavg_conversion_rate: 0.0286,
                },
            ],
            queryContext: { datasourceColumns: [], settings: {} },
            status: 'ok',
            statusMessage: '',
            isLoading: false,
            sqlAndJsProcessing: '',
        });
    });
};
